import { FunctionComponent } from 'react'
import { steps } from 'modules/onboarding'

import {
  Container,
  Header,
  Document,
  Doc,
  Action,
  Button,
  Heading,
  Paragraph,
  ImgRG,
  ImgCNH,
} from './styles'

type TProps = {
  setSelectedStep?(step: number): void
}

const SelecionaDoc: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  return (
    <Container>
      <Header />
      <Document>
        <Heading variant="h3">Documento</Heading>
        <div>
          <Heading variant="h4">Atenção</Heading>
          <Paragraph variant="p1">
            Seu documento precisa estar aberto para validarmos frente e verso,
            como no exemplo a seguir:
          </Paragraph>
        </div>
        <div>
          <Doc>
            <ImgRG />
            <Heading variant="h4">RG</Heading>
          </Doc>
          <Doc>
            <ImgCNH />
            <Heading variant="h4">CNH</Heading>
          </Doc>
        </div>
      </Document>
      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.Cadastro)}
        >
          Voltar
        </Button>
        <Button
          type="button"
          variant="contained"
          size="lg"
          form="cadForm"
          onClick={() => setSelectedStep(steps.UploadDoc)}
        >
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default SelecionaDoc
